/**
 * Space-specific notification helpers.
 * Delegates to the shared {@link fireChannelNotification}.
 */

import {
  fireChannelNotification,
  type ChannelNotificationDeps,
} from './channelNotifications';

export type { ChannelNotificationDeps as SpaceNotificationDeps } from './channelNotifications';

export interface SpaceNotificationOptions {
  onClick?: () => void;
  isViewingChannel?: boolean;
  nativeTag: string;
  expiresAt?: string;
  isMention?: boolean;
}

export function fireSpaceNotification(
  title: string,
  body: string,
  options: SpaceNotificationOptions,
  deps: ChannelNotificationDeps,
): void {
  fireChannelNotification(title, body, {
    onClick: options.onClick,
    isViewingChannel: options.isViewingChannel,
    nativeTag: options.nativeTag,
    expiresAt: options.expiresAt,
    isMention: options.isMention,
  }, deps);
}
